export default __webpack_public_path__ + "static/women-bodymap-anterior-df626a3d23bd88803b140c410132d363.webp";